import { AlertTriangle, Info } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const AVISOS = [
  "Este site possui finalidade exclusivamente informativa.",
  "Os sinais exibidos são apenas informativos e não constituem garantia de resultados.",
  "Nenhum dado apresentado assegura ganhos, lucros ou qualquer retorno financeiro.",
  "Jogos de azar envolvem riscos e resultados dependem exclusivamente de fatores aleatórios.",
  "Não existe método capaz de prever ou garantir resultados em jogos.",
  "Utilize qualquer informação com responsabilidade e senso crítico.",
  "Este conteúdo não constitui aconselhamento financeiro nem incentivo à prática de jogos.",
  "Jogue apenas se isso for permitido em sua jurisdição e somente para entretenimento.",
  "Caso os jogos deixem de ser uma forma de lazer ou estejam causando prejuízos financeiros, interrompa a atividade e procure orientação especializada.",
];

export const Avisos = () => (
  <section className="relative py-20 md:py-28" data-testid="disclaimer-section">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <Reveal className="text-center mb-10">
        <Overline>Leia com Atenção</Overline>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold tracking-tight uppercase text-white">
          Informações <span className="text-gold-gradient">Importantes</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div
          className="glass-gold p-6 md:p-10 relative overflow-hidden"
          style={{ borderColor: "rgba(242, 140, 40,0.3)" }}
        >
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#F28C28]/10 blur-3xl" />
          <div className="flex items-center gap-3 mb-7 relative">
            <div className="w-11 h-11 rounded-full bg-[#FFD84D]/10 border border-[#FFD84D]/30 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-[#FFD84D]" />
            </div>
            <div className="font-display font-bold text-white text-lg">
              Aviso de Jogo Responsável
            </div>
          </div>

          <ul className="space-y-4 relative">
            {AVISOS.map((a, i) => (
              <li
                key={i}
                className="flex gap-3 text-white/65 leading-relaxed font-body"
                data-testid={`disclaimer-item-${i}`}
              >
                <Info className="w-4 h-4 text-[#F5C542] shrink-0 mt-1" />
                <span className="text-sm md:text-base">{a}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 pt-6 border-t border-white/10 text-center relative">
            <span className="text-xs tracking-[0.2em] uppercase text-white/40 font-display">
              +18 • Jogue com Responsabilidade
            </span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
